'use strict'
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    messages: []
  },
  getters: {
    message (state) { return state.messages[0] }
  },
  actions: {
    load (context) {
      return axios.get('/1.0/site/notification').then(r => {
        let list = r.data.data[0] || []
        context.commit('set_messages', list)
      })
    }
  },
  mutations: {
    set_messages (state, v) {
      state.messages = v
    }
  }
}
